import { Injectable } from '@angular/core';
import { MxConstans, MxConstansService } from './mx.constans.service';

@Injectable({
  providedIn: 'root',
})
export class MxBrowserStorageService {
  constructor() {}

  static set(
    type: MxStorageType,
    key: string,
    value: any,
    withoutPrefix: boolean = false
  ): void {
    const storageData: { key: string; value: string } = {
      key: withoutPrefix
        ? `${key}`
        : `${MxConstansService.get(MxConstans.LOCAL_STORAGE_PREFIX)}-${key}`,
      value: JSON.stringify(value),
    };

    if (type === MxStorageType.Local) {
      localStorage.setItem(storageData.key, storageData.value);
    } else {
      sessionStorage.setItem(storageData.key, storageData.value);
    }
  }

  static get(
    type: MxStorageType,
    key: string,
    withoutPrefix: boolean = false
  ): any {
    const storageData: { key: string } = {
      key: withoutPrefix
        ? `${key}`
        : `${MxConstansService.get(MxConstans.LOCAL_STORAGE_PREFIX)}-${key}`,
    };

    return JSON.parse(
      type === MxStorageType.Local
        ? localStorage.getItem(storageData.key)
        : sessionStorage.getItem(storageData.key)
    );
  }

  static remove(
    type: MxStorageType,
    key: string,
    withoutPrefix: boolean = false
  ): void {
    const storageData: { key: string } = {
      key: withoutPrefix
        ? `${key}`
        : `${MxConstansService.get(MxConstans.LOCAL_STORAGE_PREFIX)}-${key}`,
    };

    if (type === MxStorageType.Local) {
      localStorage.removeItem(storageData.key);
    } else {
      sessionStorage.removeItem(storageData.key);
    }
  }

  static clear(type: MxStorageType): void {
    if (type === MxStorageType.Local) {
      localStorage.clear();
    } else {
      sessionStorage.clear();
    }
  }
}

export enum MxStorageType {
  Local = 10,
  Session = 20,
}
